
export function blobToBase64(blob) {
    return new Promise((resolve, _) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result);
        reader.readAsDataURL(blob);
    });
}

export function formatNumberto0(num) {
    return num >= 10 ? `${num}` : `0${num}`;
}


export function formatPrice(price) {
    const symbols = ["", "K", "M", "B", "T", "Q", "Qu"]; // Magnitude symbols
    const magnitude = Math.floor(Math.log10(price) / 3); // Calculate magnitude
    let convertedPrice = price / Math.pow(10, magnitude * 3);
    convertedPrice = convertedPrice.toFixed(2); // Ensure 2 decimal places
    return `${convertedPrice}${symbols[magnitude]}`;
  }
  

export function formateNumbersToComma(number) {
    if (!number || number === "") return "";

    let originalNumber = parseFloat(number);
    let roundedNumber = Math.ceil(originalNumber);

    let numberStr = roundedNumber.toString();

    // Check if the price contains a decimal point
    let decimalIndex = numberStr.indexOf(".");
    let decimalPart = "";
    if (decimalIndex !== -1) {
        // Extract the decimal part of the price
        decimalPart = numberStr.slice(decimalIndex);
        numberStr = numberStr.slice(0, decimalIndex);
    }

    // Add commas every three digits from the right
    let formattedPrice = "";
    for (let i = numberStr.length - 1, count = 0; i >= 0; i--, count++) {
        if (count && count % 3 === 0) {
            formattedPrice = "," + formattedPrice;
        }
        formattedPrice = numberStr[i] + formattedPrice;
    }

    // Append the decimal part and return the formatted price
    let resValue = `${formattedPrice + decimalPart}`;

    return resValue;
}


export function formatDateTimeForMsg(date) {

    if (date instanceof Date) {
        const now = new Date();
        const diff = now - date; // Difference in milliseconds
        // Format time if the date is today
        if (diff < 86400000 && date.getDate() === now.getDate()) {
            return date.toLocaleTimeString('en-US', {hour: 'numeric', minute: 'numeric'});
        }
        // Format as "Yesterday" if the date is yesterday
        if (diff < 172800000 && date.getDate() === now.getDate() - 1) {
            return 'Yesterday ' + date.toLocaleTimeString('en-US', {hour: 'numeric', minute: 'numeric'});
        }
        return date.toLocaleString('en-US').replace(/\//g, '-');

    } else return ""
}

export function nFormatter(num, digits) {
    const lookup = [
        {value: 1, symbol: ""},
        {value: 1e3, symbol: "k"},
        {value: 1e6, symbol: "M"},
        {value: 1e9, symbol: "G"},
        {value: 1e12, symbol: "T"},
        {value: 1e15, symbol: "P"},
        {value: 1e18, symbol: "E"}
    ];
    const regexp = /\.0+$|(?<=\.[0-9]*[1-9])0+$/;
    const item = lookup.findLast(item => num >= item.value);
    return item ? (num / item.value).toFixed(digits).replace(regexp, "").concat(item.symbol) : "0";
}

export function sleep(milliseconds = 1) {
    return new Promise(resolve => {
        setTimeout(resolve, milliseconds); // Wait for 1 minute (60,000 milliseconds)
    });
}

export const SUBSCRIPTION_ENABLED = false; // Set to true or false based on your requirement

// Posts lock for editing 3 minutes after creation. Frontend-only enforcement.
export const POST_LOCK_WINDOW_MS = 3 * 60 * 1000; // 3 minutes

export const isPostLocked = (createdAt) => {
    if (!createdAt) return false;
    const created = new Date(String(createdAt).replace(" ", "T")).getTime();
    if (Number.isNaN(created)) return false;
    return Date.now() - created > POST_LOCK_WINDOW_MS;
};

// Username/handle rule: lowercase letters, numbers, period and underscore only.
// No spaces, no capitals. The full-name field is unrestricted; this is the handle.
export const USERNAME_REGEX = /^[a-z0-9._]+$/;
export const USERNAME_HINT =
    "Lowercase letters, numbers, periods, and underscores only. No spaces.";

// Coerce any typed value into a valid handle: lowercase and drop disallowed chars.
export const sanitizeUsername = (value) =>
    (value || "").toLowerCase().replace(/[^a-z0-9._]/g, "");

export const MIN_BIO_WORDS = 3;
export const countWords = (value) =>
    value ? value.trim().split(/\s+/).filter(Boolean).length : 0;

// Quill emits "<p><br></p>" for empty content. Treat tag/whitespace-only HTML as empty.
export const isQuillEmpty = (html) => {
    if (!html) return true;
    const text = String(html)
        .replace(/<[^>]*>/g, "")
        .replace(/&nbsp;/g, " ")
        .replace(/\s/g, "");
    return text.length === 0;
};
